import { render, staticRenderFns } from "./Preload.vue?vue&type=template&id=2ba01402&"
import script from "./Preload.vue?vue&type=script&lang=js&"
export * from "./Preload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports